// base_info_view_5_1 
import React, { useRef, useState, useEffect } from 'react'
import BaseListView1 from './base_list_view_1'
import { Tabs, Badge, Checkbox, Button,LucideIcon } from './ot'
import {
    Eye,
    MousePointer,
    FileText,
    TrendingUp,
    Edit,
    Share,
    Download,
} from "lucide-react"
const BaseInfoView6_1 = ({
    rowKey = 'key',
    data = [
        {
            key: "1",
            baseListView1_1Props: {
                checked: false,
                onCheckedChange: () => { }
            },
            baseListView1_2Props: {
                value: "Facebook / 產品介紹 / 推薦文 / 精簡版",
            },
            baseListView1_3Props: {
                value: "元件項目：標題、主文內容、圖片、按鈕、Hashtag",
            },
            baseListView1_4Props: {
                stats: [
                    {
                        value: 1250,
                        label: "瀏覽次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <Eye className="h-4 w-4 text-blue-500" />
                    },
                    {
                        value: 45,
                        label: "撰寫文案",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <FileText className="h-4 w-4 text-green-500" />


                    },
                    {
                        value: 320,
                        label: "點擊次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <MousePointer className="h-4 w-4 text-purple-500" />

                    },
                    {
                        value: 28,
                        label: "複製次數",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <TrendingUp className="h-4 w-4 text-orange-500" />

                    },
                ]
            },
            baseListView1_5Props: {
                badges: [
                    {
                        label: "王小明",
                        variant: "outline",
                        className: ""
                    },
                    {
                        label: <><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                            <path d="M8 11h8" />
                            <path d="M8 15h8" />
                            <path d="M8 7h8" />
                        </svg>2025-05-30</>,
                        variant: "outline",
                        className: ""
                    },
                ]
            },
            baseListView1_6Props: {
                children: <p className="text-gray-600 mt-1 text-sm">儲存位置：.../.../...</p>
            },
            baseListView1_7Props: {
                buttons: [
                    <Button variant="outline" className="flex-1">
                        <Eye className="h-4 w-4 mr-1" />
                        查看
                    </Button>,
                    <Button className="flex-1">
                        <Edit className="h-4 w-4 mr-1" />
                        複製文案內容並編輯
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Share className="h-4 w-4 mr-1" />
                        分享
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Download className="h-4 w-4 mr-1" />
                        匯出
                    </Button>,
                    <Button variant="ghost" size="sm" className="text-red-600">
                        刪除
                    </Button>,
                ],
                buttonGroupsColumnsCount: [2, 3],
            },
        },

    ],
    onBaseListView1CheckChange = () => {

    },
    baseListView1ShowComponent = [
        "BaseListView1_1",
        "BaseListView1_2",
        "BaseListView1_3",
        "BaseListView1_4",
        "BaseListView1_5",
        "BaseListView1_6",
        "BaseListView1_7",
    ],
}) => {

    const dataToBaseListView1Props = (data) => {
        let newData = data.map((value) => {
            return {
                ...value,
                baseListView1_1Props: {
                    ...value?.baseListView1_1Props,
                    onCheckedChange: (checked) => onBaseListView1CheckChange(checked, value )
                }
            }
        })
        return newData
    }
    return (<div className="space-y-3">
        {dataToBaseListView1Props(data).map((baseListView1Value) => {
            return <BaseListView1
                showComponent={baseListView1ShowComponent}
                {...baseListView1Value}
            />
        })}
        {/* 無結果提示 */}
        {dataToBaseListView1Props(data).length === 0 && (
            <div className="text-center py-12">
                <div className="text-gray-400 mb-2">
                    <LucideIcon name={"Search"} className="h-12 w-12 mx-auto" />
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-1">找不到相關內容</h3>
                <p className="text-gray-500">請嘗試調整搜索關鍵字或篩選條件</p>
            </div>
        )}
    </div>



    )
}
export default BaseInfoView6_1
